module.exports = __webpack_public_path__ + "static/img/ic_special_vip_mine_1_1.8703aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_special_vip_mine_1_1.png
// module id = 4goW
// module chunks = 0